import xtend from 'xtend';
import apply from 'ramda/src/apply';
import S from 'pull-stream';
import store from 'pull-store';
import Pushable from 'pull-pushable';
import _ from 'underscore';
import path from 'ramda/src/path';
import assocPath from 'ramda/src/assocPath';
import dissocPath from 'ramda/src/dissocPath';
import curry from 'ramda/src/curry';
import flip from 'ramda/src/flip';
import propEq from 'ramda/src/propEq';
import find from 'ramda/src/find';
import assoc from 'ramda/src/assoc';
import pathOr from 'ramda/src/pathOr';
import ErrorState from 'model-fns/errors';
import RequestState from 'model-fns/request';
import formatDate from 'date-fns/format'

import request from '../lib/requests';
import apiHelpers from '../../utils/Formatter';
let apiDate = apiHelpers.toApiDateString
import Ev from '../../lib/event';
import DB from '../../lib/mime-db.js';
import mimeLib from 'mime-types';
let mime = mimeLib(DB)

function ChannelModel () {
    return xtend(ErrorState(), RequestState(), {
        pendingEdits: {},
        choosingAssets: false,
        channelType: 'managed',
        channel: {},
        isValid: false,
        addSuccess: null,
        editSuccess: null,

        // @TODO factor this differently
        // the upload stuff should be a reusable component
        assetUploadInProgress: false,
        assetUploadProgress: 0,
        assetUploadName: ''
    });
}

ChannelModel.effects = function (api) {
    var fns = {
        save: function (state, ev) {
            var data = xtend(state.channel, state.pendingEdits, {
                // @TODO
                // this is set statically until we offer other devices
                ottTargets: ['roku']
            });
            if (data.ottChannelID) {
                return request('edit', api.ott.edit.bind(api.ott, data));
            }
            data.beginDate = state.pendingEdits.beginDate || apiDate();
            data.channelType = state.channelType;
            if (!data.channelType) delete data.channelType;
            data.language = 'en';
            return request('add', api.ott.add.bind(api.ott, data));
        },

        startUpload: function (state, file) {
            // console.log('in here, the upload', file);
            var type = file.type || mime.lookup(file.name);

            if (!type) {
                var err = new Error('File/MIME Type Unsupported');
                return S.once(Ev('pushError', err));
            }

            var uploadStream = Pushable();

            uploadStream.push(Ev('uploadStart', file));
            var up = api.assetUpload({
                fileName: file.name,
                body: file,
                ContentType: type + ';charset=utf-8'
            }, function onComplete (err, data) {
                if (err) {
                    uploadStream.push(Ev('pushError', err));
                    uploadStream.push(Ev('uploadComplete', null));
                    uploadStream.end();
                    return;
                }

                uploadStream.push(Ev('uploadComplete', null));
                uploadStream.end();
            });

            var prev;
            up.on('httpUploadProgress', function (data) {
                var p = data.loaded / data.total * 100;
                var percent = Math.floor(p);
                if (prev !== percent) {
                    uploadStream.push(Ev('uploadProgress', percent));
                    prev = percent;
                }
            });

            return uploadStream;
        }

    };

    return apply(function mapToEffect (state, ev) {
        var fn = fns[Ev.type(ev)];
        if (!fn) return S.once(ev);
        return fn(state, Ev.data(ev));
    });
};

var paths = {
    pendingFeeds: ['pendingEdits', 'persistentStreams'],
    pendingCats: ['pendingEdits', 'categories'],
    cats: ['channel', 'categories'],
    feeds: ['channel', 'persistentStreams'],
    pendingDefaultImage: ['pendingEdits', 'defaultImage'],
    defaultImage: ['channel', 'defaultImage'],
    pendingChannelName: ['pendingEdits', 'channelName'],
    channelName: ['channel', 'channelName'],
    pendingTargets: ['pendingEdits', 'ottTargets'],
    targets: ['channel', 'ottTargets']
};

var setPending = curry(function (idKey, path, state, ev) {
    // if (!ev.length) return dissocPath(path, state);
    return assocPath(
        path,
        toListWithImages(
            idKey,
            pathOr([], path, state),
            _(ev).map('value')
        ),
        state
    );
});

function toListWithImages (idKey, oldList, newList) {
    return newList.reduce(function (acc, id) {
        return acc.concat(
            find(propEq(idKey, id), oldList) ||
            assoc(idKey, id, { defaultImage: null })
        );
    }, []);
}

function getSelected (_default, paths, state) {
    for (var i = 0; i < paths.length; i++) {
        var p = path(paths[i], state);
        if (p !== undefined) return p;
    }
    return _default;
}

var selectSourceImage = curry(function (pendingPath, keyProp, state, ev) {
    var i = _(path(pendingPath, state)).findIndex(function (x) {
        return x[keyProp] === state.choosingAssets[keyProp];
    });
    return _.compose(
        ChannelModel.update.closeAssetModal,
        assocPath(
            pendingPath.concat(i),
            xtend(path(pendingPath.concat(i), state), {
                defaultImage: ev.assetID
            })
        )
    )(state);
});

ChannelModel.update = xtend(ErrorState.update, RequestState.update, {
    selectCategory: function (state, ev) {
        const currentCategories = path(paths.pendingCats, state) || path(paths.cats, state) || []
        const newEv = ev.map(selectedCat => {
            // convert { value:'cat id', label:'l' } to { categoryID: 'cat id', defaultImage:'1234'}
            // based on any existing defaultImage set for that category or null 
            const found = currentCategories.find(currentCat => currentCat.categoryID === selectedCat.value)
            return {...selectedCat, categoryID: selectedCat.value, defaultImage: found && found.defaultImage || null}
        })

        return assocPath(
            paths.pendingCats,
            newEv,
            state
        )

        // return setPending('categoryID', paths.pendingCats, state, newEv);
    },
    selectFeed: setPending('encoderID', paths.pendingFeeds),
    browseImages: flip(assocPath(['choosingAssets'])),
    closeAssetModal: assocPath(['choosingAssets'], false),
    changeBeginDate: flip(assocPath(['pendingEdits', 'beginDate'])),
    changeChannelName: flip(assocPath(paths.pendingChannelName)),

    uploadStart: function (state, file) {
        return xtend(state, {
            assetUploadInProgress: true,
            assetUploadName: file.name
        });
    },

    uploadProgress: function (state, ev) {
        // console.log('prog', ev);
        return xtend(state, { assetUploadProgress: ev });
    },

    uploadComplete: function (state, ev) {
        return xtend(state, {
            assetUploadInProgress: false,
            assetUploadProgress: 0,
            assetUploadName: ''
        });
    },

    edit: function (state, ev) {
        return xtend(state, {
            pendingEdits: {},
            editSuccess: true,
            channel: ev
        });
    },

    add: function (state, ev) {
        return xtend(state, {
            pendingEdits: {},
            addSuccess: true,
            channel: ev
        });
    },

    getChannelByID: function (state, ev) {
        return xtend(state, {
            channel: ev
        });
    },

    changeTarget: function (state, ev) {
        var remove = _.contains(
            pathOr([], paths.pendingTargets, state),
            ev
        );
        var pending = remove ?
            _.without(
                pathOr([], paths.pendingTargets, state),
                ev
            ) :
            pathOr([], paths.pendingTargets, state).concat(ev)
        ;

        var targets = pathOr([], paths.targets, state);
        if ( _.isEqual(pending.sort(), targets.sort()) ) {
            return dissocPath(paths.pendingTargets, state);
        }
        return assocPath(paths.pendingTargets, pending, state);
    },

    channelTypeChange: flip(assocPath(['channelType'])),

    chooseImage: function (state, ev) {
        return _.compose(
            ChannelModel.update.closeAssetModal,
            assocPath(paths.pendingDefaultImage, ev.assetID)
        )(state);
    },

    selectCategoryImage: (state, ev) => {
        let srcPath = paths.cats
        if (path(paths.pendingCats, state)) {
            srcPath = paths.pendingCats
        }
        return selectSourceImage(srcPath, 'categoryID')(state, ev)
    },
    selectStreamImage: (state, ev) => {
        let srcPath = paths.feeds
        if (path(paths.pendingFeeds, state)) {
            srcPath = paths.pendingFeeds
        }
        return selectSourceImage(srcPath, 'encoderID')(state, ev)
    }
});

// @TODO factor this better
ChannelModel.store = function () {
    var stateStream = store(function (state, ev) {
        return ChannelModel.update[ev[0]](state, ev[1]);
    }, ChannelModel());

    function channelState () {
        return S(
            S.filter(function (ev) {
                return ChannelModel.update[Ev.type(ev)];
            }),

            stateStream(),

            S.map(_.compose(
                validate,
                view
            ))
        );
    }

    channelState.state = stateStream.state;
    return channelState;
};

function view (state) {
    return xtend(state, {
        selectedCategories: path(paths.pendingCats, state) ||
            path(paths.cats, state) ||
            [],
        selectedFeeds: path(paths.pendingFeeds, state) ||
            path(paths.feeds, state) ||
            [],
        selectedDefaultImage: getSelected(
            null,
            [paths.pendingDefaultImage, paths.defaultImage],
            state
        ),
        selectedDate: getSelected(
            formatDate(new Date(), 'YYYY-MM-DD'),
            [
                ['pendingEdits', 'beginDate'],
                ['channel', 'beginDate']
            ],
            state
        ),

        channelName: path(paths.pendingChannelName, state) ||
            pathOr('', paths.channelName, state),

        targets: getSelected(
            [],
            [paths.pendingTargets, paths.targets],
            state
        )
    });
}

function validate (state) {
    // selected categories can have images added/changed and those are set in state without changes to pending edits
    // if (!Object.keys(state.pendingEdits).length) {
    //     return xtend(state, { isValid: false });
    // }

    var valid = _.every([
        (state.selectedCategories.length || state.selectedFeeds.length),
        state.channelName,
        state.selectedDefaultImage
    ]);

    return xtend(state, { isValid: valid });
}

export default ChannelModel;
